import { createReducer } from 'redux-act'
import u from 'updeep'

import { update, clear, receive } from 'actions/reservation'
import { switchLocale } from 'actions/ui'
import { couponCodeValidated, couponValidationRequested } from 'actions/coupons'

const initialState = {
  id: '',
  step: 'auth',
  activeTab: 0,
  data: {
    phone: '',
    code: '',
    email: window.__email || '',
    first_name: window.__firstName || '',
    last_name: window.__lastName || '',
    guests: 0,
    language: '',
    ui_language: '',
    note: '',
    start: '',
    coupon_code: '',
    timezone: '',
  },
  coupon: {
    validating: false,
  },
  type: '',
  dates: [],
  datesNotRealTime: [],
}

export default createReducer({
  [clear]: () => initialState,
  [update]: (state, payload) => {
    return u(payload, state)
  },
  [receive]: (state, { id, uuid, response }) => {
    const data = response
    const coupon = Object.assign({ validating: false }, response.coupon_usage)
    data.id = id
    return u({ uuid, data, coupon }, state)
  },
  [switchLocale]: (state, { locale }) => {
    return u({ data: { ui_language: locale } }, state)
  },
  [couponValidationRequested]: (state, { coupon_code }) => {
    return u({
      coupon: { validating: true },
      data: { coupon_code },
    }, state)
  },
  [couponCodeValidated]: (state, coupon) => {
    coupon.validating = false // eslint-disable-line no-param-reassign
    return Object.assign({}, state, { coupon })
  },
}, initialState)
